import { render, staticRenderFns } from "./PQNavBar.vue?vue&type=template&id=dc8040a8&"
import script from "./PQNavBar.vue?vue&type=script&lang=js&"
export * from "./PQNavBar.vue?vue&type=script&lang=js&"
import style0 from "./PQNavBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports